import React from "react";
import GlobalTrade from "./GlobalTrade";

export default function Features() {
  return (
    <div className="    border border-sidom-light dark:border-sidom-blue">
      <GlobalTrade />

      <div className="flex flex-col mb-[40px] mt-[100px]  items-center w-full text-sidom-dark dark:text-sidom-light">
        <div className="w-full aspect-video max-h-[900px] ">
          <video
            controls
            autoPlay
            muted
            loop
            className="w-full h-full object-cover aspect-video shadow-md"
          >
            <source
              src="https://api.institucional.global.sidom.io/uploads/presentacion_gt_mej_7c5618d96b.mp4"
              type="video/webm"
            />
          </video>
        </div>
        <div className="w-full container    leading-[1.3]  text-left">
          <h2 className="text-sidom-orange text-4xl md:text-5xl mt-[60px] font-extrabold">
            ¿Cómo logramos esto?
          </h2>
        </div>

        <div className="w-full container   mt-[60px] leading-[1.3] flex justify-center">
          <div className=" text-left   text-base md:text-lg leading-relaxed space-y-6 first-line:">
            <p>
              Mediante la implementación de tecnologías de Automatización
              Robótica de Procesos (RPA) e Inteligencia Artificial,{" "}
              <strong>SIDOM</strong> ha eliminado las barreras que obstaculizan
              el comercio internacional, optimizando la eficiencia y reduciendo
              los costos operativos.
            </p>
            <p>
              En <strong>SIDOM</strong>, tenemos la misión de convertirnos en un
              socio tecnológico global llevando los negocios internacionales de
              nuestros clientes a un nivel superior.
            </p>
            <p>
              Desde <strong>SIDOM GT</strong> buscamos construir un mundo en el
              que los negocios fluyan sin obstáculos, donde las transacciones
              sean seguras, rápidas y eficientes, ya que creemos firmemente que
              el futuro del comercio exterior es la tecnología aplicada para
              hacer Simple lo Complejo.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
